import React from "react";
import "../../Styles/yellowcalf.css/Reports.css";

function Reports() {
  return (
    <div className="reports-container" style={{paddingTop:"25px"}}>
      <div className="reports-grid">
        
        <div className="reports-card">
          <div className="reports-card-header">
            <h4>Cashless Reports</h4>
          </div>

          <div className="reports-card-body">
            <table className="reports-table">
              <tbody>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/wallet">Cashless Balance Report</a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/wallet/walletsale">Wallet Sales Report</a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/wallet/operatorsale">
                      Wallet Sales Report based on Operator
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        
        <div className="reports-card">
          <div className="reports-card-header">
            <h4>Finance Reports</h4>
          </div>

          <div className="reports-card-body">
            <table className="reports-table">
              <tbody>
                <tr>
                  <td><i class="bi bi-truck-front"></i></td>
                  <td>
                    <a href="/accountant/reports/expense/">Vehicle Expense Report</a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/reports/billing/">Transportation Details</a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/reports/expense/collection">Collection Report</a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/reports/invoice">Invoice Balance Report</a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/reports/expense/feepaid">
                      Yearly Income Summary Report
                    </a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/reports/siblings">Siblings Report</a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/reports/balance">
                      Terms/Semester Wise Balance Report
                    </a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/reports/specialfee">Special Fee Report</a>
                  </td>
                </tr>
                <tr>
                  <td><i class="bi bi-person-fill"></i></td>
                  <td>
                    <a href="/accountant/reports/parentstransaction">
                      Payment Mode Report
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reports;
